import { Action } from "../../../actions/actions";
import { HomeActionTypes } from "../actions/actionTypes";
import {User} from "../../auth/reducers/users.reducer";


export function userInfo(state: User = null, action: Action): User {
    switch (action.type) {
        case HomeActionTypes.GET_USER_INFO_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function userLoading(state: User = null, action: Action) {
    switch (action.type) {
        case HomeActionTypes.GET_USER_INFO:
            return true
        case HomeActionTypes.GET_USER_INFO_SUCCESS:
            return false;
        default:
            return false;
    }
}
